import type { Row } from '@tanstack/react-table';
import { MoreHorizontal } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@ui/dropdown-menu.tsx';
import { Button } from '@r/components/ui/button.tsx';
import { useTranslation } from 'react-i18next';
import { RotateCcw, PencilLine } from 'lucide-react';

interface LocaleRowData {
  id?: number;
  isCustom?: boolean;
  isEditable?: boolean;
}

interface DataTableRowActionsProps<TData extends LocaleRowData> {
  row: Row<TData>;
  onEditLocale: (value: TData) => void;
  onDeleteLocale: (value: TData) => void;
}

const AdminDataTableRowActions = <TData extends LocaleRowData>({
  row,
  onEditLocale,
  onDeleteLocale
}: DataTableRowActionsProps<TData>) => {
  const { t } = useTranslation();

  const locale = row.original;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex h-8 w-8 p-0 data-[state=open]:bg-muted float-end">
          <MoreHorizontal className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onEditLocale(locale)}>
          <PencilLine className="mr-2 w-4 h-4" />
          {t('admin.label.edit.translation')}
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={() => onDeleteLocale(locale)} className="text-orange-600">
          <RotateCcw className="mr-2 w-4 h-4" />
          {t('admin.label.rollback.translation')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export { AdminDataTableRowActions };
